import { render, staticRenderFns } from "./ClearCohortsPage.vue?vue&type=template&id=2c4fcec7"
import script from "./ClearCohortsPage.vue?vue&type=script&lang=js"
export * from "./ClearCohortsPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports